<script setup lang="ts">
  import { Badge, type BadgeVariants } from "@/components/ui/badge";

  defineProps<{
    status: string;
    variants: Record<string, BadgeVariants["variant"]>;
    labels?: Record<string, string>;
    dot?: boolean;
    dotClass?: string;
  }>();
</script>

<template>
  <Badge
    :variant="variants[status] ?? 'neutral'"
    class="rounded-full border-transparent px-2.5 py-0.5 text-xs capitalize">
    <span
      v-if="dot"
      class="size-1.5 rounded-full bg-current"
      :class="dotClass" />
    {{ labels?.[status] ?? status }}
  </Badge>
</template>
